<template>
  <div>
    <ContentWrapperControl>
      <div class="bg-white p-4 rounded-b-lg shadow border-b mb-4">
        <div class="mb-2 text-md font-bold">
          <span v-text="lang('lbl_0000040') + ', '"></span>
          <span v-text="getName()"></span>!
        </div>
        <div
          v-text="lang('lbl_0000272')"
          class="text-sm leading-normal text-grey-darkest"
        ></div>
      </div>
      <InfoGroupControl v-bind:title="lang('lbl_0000274')">
        <InfoBarControl
          v-show="mobile == null"
          type="to-do"
          v-bind:value="mobile"
          v-bind:title="lang('lbl_0000021')"
          icon="papsi_setting_mobile.svg"
          :show_border="email == null"
          :required="true"
          href="/user/enroll/mobile"
        />
        <InfoBarControl
          v-show="email == null"
          type="to-do"
          v-bind:value="email"
          v-bind:title="lang('lbl_0000022')"
          icon="papsi_setting_email.svg"
          :show_border="false"
          :required="true"
          href="/user/enroll/email"
        />
      </InfoGroupControl>
      <PrivacyInfoControl />
    </ContentWrapperControl>
  </div>
</template>

<script>
import ContentWrapperControl from "./../../components/controls/ContentWrapperControl.vue";
import PrivacyInfoControl from "@/components/controls/PrivacyInfoControl.vue";
import InfoBarControl from "@/components/controls/InfoBarControl.vue";
import InfoGroupControl from "@/components/controls/InfoGroupControl.vue";
import mixin from "./../../mixin.js";
import User from "@/services/User";

export default {
  mixins: [mixin],
  components: {
    ContentWrapperControl,
    PrivacyInfoControl,
    InfoBarControl,
    InfoGroupControl,
  },
  data() {
    return {
      show: false,
      name: null,
      email: null,
      mobile: null,
      tin: null,
      date_of_birth: null,
      otp_login: false,
      pin_login: false,
    };
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("nofooter", true);
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000291"),
      show: true,
      back: true,
    });

    let state = this.$store.state;
    this.name = state.info.first_name || "";
    this.email = state.info.email ?? null;
    this.mobile = state.info.mobile_no ?? null;
    this.otp_login = state.otp_login;
    this.pin_login = state.pin_login;
  },
  methods: {
    proceed() {
      let state = this.$store.state;

      if (state.login && !state.has_pin) {
        this.$router.push("/user/enroll/pin");
        return;
      }

      this.$emit("login");
      this.$router.push("/dashboard");
    },
    logout() {
      let that = this;

      that.$emit("showloader");
      User.logout()
        .then(function () {
          that.destroyCookies();
          that.resetUserData();
          that.$emit("logout");
          that.$emit("hideloader");
          that.$router.push("/");
        })
        .catch(function (error) {
          that.$emit("error", error);
        });
    },
  },
};
</script>
